enum TRIP_PROFILE_PACE {
  SLOW = 'SLOW',
  MODERATE = 'NORMAL',
  PACKED = 'FAST',
}

export default TRIP_PROFILE_PACE;
